import { useEffect, useState } from "react";
import { getCompanyById } from "./axios/companyAxios";
import { useEnumApi } from "contexts/EnumApiContext";
import { getCompanyInfoByDomain } from "./axios/commonAxios";
import { useSelector } from "react-redux";
import useConfig from "hooks/useConfig";
import Logo from "layout/monitoring/logo-china.svg";
import Logo1 from "layout/monitoring/logo1-china.svg";

const LogoImg = () => {
  const { loginInfo } = useEnumApi();
  const { mode } = useConfig();
  const hostname = window.location.hostname;

  const { isLogoUrlUpdated, logoUpdatedAt } = useSelector(
    (state) => state.company
  );

  const isChina = process.env.REACT_APP_TIMEZONE === 'Asia/Shanghai';
  const isKorean = process.env.REACT_APP_LANGUAGE === 'ko';

  const defaultLogo =
    isChina && !isKorean
      ? mode === "light"
        ? Logo1
        : Logo
      : `${process.env.PUBLIC_URL}/img/login_logo2.png`;

  // const [imageSrc, setImageSrc] = useState(defaultLogo);
  const [imageSrc, setImageSrc] = useState(null);

  // useEffect(() => {
  //   if (!loginInfo?.company?.id) {
  //     setImageSrc(defaultLogo);
  //   }
  // }, [defaultLogo]);

  const applyLogo = (url) => {
    let finalUrl = url || defaultLogo;
    if (logoUpdatedAt) {
      finalUrl += `?v=${logoUpdatedAt}`;
    }
    setImageSrc(finalUrl);
  };

  useEffect(() => {
    if (loginInfo?.company?.id) {
      getCompanyById(loginInfo.company.id).then((res) => {
        const id = res?.info?.logoFile?.id;
        if (id) {
          applyLogo(
            `${window.RUNTIME_CONFIG.REACT_APP_API_URL}/api/download/${id}`
          );
        } else {
          applyLogo();
        }
      });
      return;
    }

    if (hostname !== "localhost") {
      getCompanyInfoByDomain({ domain: hostname })
        .then((res) => {
          const id = res?.logoFile?.id;
          if (id) {
            applyLogo(
              `${window.RUNTIME_CONFIG.REACT_APP_API_URL}/api/download/${id}`
            );
          } else {
            applyLogo();
          }
        })
        .catch(() => applyLogo());
      return;
    }

    applyLogo();
  }, [loginInfo, isLogoUrlUpdated, logoUpdatedAt, defaultLogo]);

  if (!imageSrc) return null;

  return <img src={imageSrc} alt="logo" style={{ width: "180px" }} />;
  // return <img src={imageSrc} alt="logo" style={isChina ? { width: "180px" } : undefined} />;
};

export default LogoImg;
